<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17McvA9/tc-custom/9781644034767.jpg?1731160443074" alt="This image is the cover for the book Jingle All the Way"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jingle All the Way
      </h1>
      <p class="bookDescription body article font2">
        <p>Stitch, share, gift, and repeat!  Nothing beats the feeling of giving and receiving a handmade gift. Gather cotton fabric, wool, or hand-dyed linen, then embellish with simple hand embroidery, rickrack, and trims to bring Christmas cheer to you and yours. Fabric designer and small business owner Debbie Busby guides you through 40 folk-art-style projects for the home. Discover how true holiday magic materializes with a few simple stitches as you make ornaments, stockings, pincushions, pillows, small wall quilts, poinsettia wreaths, and more for a cozy abode.   Full of whimsy and cheer, these adorable projects are simple enough to whip one up for everyone on your list. Get all the essential tips and tricks Debbie has gathered throughout the years and a stitch guide you’ll want to refer to over and over again! Includes an overview of supplies needed and advice on choosing the right embroidery floss, needles, and wool.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Debbie Busby
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Published by C&T Publishing, Inc.,
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?157e16b3